import MoreFilters from '../../../../clients/shared/ProjectSearch/MoreFilters';

export * from '../../../../clients/shared/ProjectSearch/MoreFilters';

export default MoreFilters;
